import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateSolicitudGastosFarmacia = () => {
  const [loadingCreateSolicitudGastosFarmacia, setLoadingCreateSolicitudGastosFarmacia] = useState(false);
  const [successCreateSolicitudGastosFarmacia, setSuccessCreateSolicitudGastosFarmacia] = useState(false);
  const [errorCreateSolicitudGastosFarmacia, setErrorCreateSolicitudGastosFarmacia] = useState(null);
  const [dataCreateSolicitudGastosFarmacia, setDataSolicitudGastosFarmacia] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const createSolicitudGastosFarmacia = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateSolicitudGastosFarmacia(true);
    setSuccessCreateSolicitudGastosFarmacia(false);
    setErrorCreateSolicitudGastosFarmacia(null);

    try {
      const payload = {
        ...data,
        UsuarioId: data?.UsuarioId ?? userId,
      };
      const res = await apiRecord.newSolicitudGastosContingenciaProfesionalFarmacia(userId, payload);

      setSuccessCreateSolicitudGastosFarmacia(true);
      setDataSolicitudGastosFarmacia(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      console.error("Error en createSolicitudGastosFarmacia:", err);
      setErrorCreateSolicitudGastosFarmacia(err.response?.data ?? err);

      throw err;
    } finally {
      setLoadingCreateSolicitudGastosFarmacia(false);
    }
  };

  return {
    createSolicitudGastosFarmacia,
    loadingCreateSolicitudGastosFarmacia,
    successCreateSolicitudGastosFarmacia,
    errorCreateSolicitudGastosFarmacia,
    dataCreateSolicitudGastosFarmacia
  };
};

export default useCreateSolicitudGastosFarmacia;
